var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1VenetianBlindGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 21H25v-6h40v6zM54 31h11v-6H54v6zm0 10h11v-6H54v6zm0 10h11v-6H54v6zM11 61h39v-6H11v6zm0-36v6h39v-6H11zm0 10v6h39v-6H11zm0 10v6h39v-6H11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Venetian_blind_group.9485c4af.svg";
export { SvgC1VenetianBlindGroup as ReactComponent };